import { GET_RS_ADMIN_USER_STATS } from "../../../../../utils/Api_enums";
import { DESC, EXTERNAL_RAC_COMPLETED_BY_CLIENT, EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES, REVIEWADMIN, REVIEWSCHEDULER, VONBOARDER } from "../../../../../utils/Constants";
import axios from "axios";

export const GET_GRID_CARD_ROWDATA = (user_type, user_id) => {

    let buckets = [];
    if (user_type == REVIEWADMIN) {

        buckets = [
            {
                "order": 0,
                "index": 10,
                "title": "Last Login",
                "dashboard_stats": "last_login",
                "description": "Profiles with active call date in future.",
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": false,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 4,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Dials Made",
                "dashboard_stats": "dials_made",
                "description": "Profiles with active call date in future.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 4,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Upcoming Calls",
                "dashboard_stats": "upcoming_calls",
                "description": "Profiles with active call date in future.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 2,
                "title": "Due Calls",
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "dashboard_stats": "due_calls",
                "description": "Profiles with active call date in future.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 19,
                "isRSAdmin": true,
                "title": "Total Scheduled Appointments",
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "dashboard_stats": "total_appointments",
                "description": "Total scheduled appointments.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                "order": 0,
                "index": 5,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Non Responsive Calls",
                "dashboard_stats": "total_non_responsive",
                "description": "Profiles that did not respond.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 8,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Requested to be Rescheduled",
                "dashboard_stats": "reschedule_appointments",
                "description": "Calls requested to be rescheduled.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true


            },
            {
                "order": 0,
                "index": 3,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Not Interested",
                "dashboard_stats": "total_not_interested",
                "description": "Users who are not interested.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 6,
                "isRSAdmin": true,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Bad Phone Number",
                "dashboard_stats": "bad_phone_number",
                "description": "Invalid or incorrect phone numbers.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                // isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 13,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Life Insurance Calls",
                "dashboard_stats": "Life Insurance",
                "description": "Calls related to life insurance.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 11,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "P&C Review Calls",
                "dashboard_stats": "P&C Review",
                "description": "Property & casualty review calls.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 14,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Retirement",
                "dashboard_stats": "Retirement",
                "description": "Calls related to retirement planning.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                "order": 0,
                "index": 15,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Office Appointments ",
                "dashboard_stats": "office_appointments",
                "description": "Calls related to retirement planning.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                "order": 0,
                "index": 16,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Phone Appointment",
                "dashboard_stats": "phone_appointments",
                "description": "Calls related to retirement planning.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                "order": 0,
                "index": 17,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Virtual Appointment ",
                "dashboard_stats": "virtual_appointments",
                "description": "Calls related to retirement planning.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                "order": 0,
                "index": 12,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Commercial/Farm",
                "dashboard_stats": "Commercial",
                "description": "Business and commercial insurance calls.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "isRSAdmin": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 10,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Call Attempts",
                "dashboard_stats": "total_call_attempts",
                "description": "Number of review scheduler attempts.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                "showName": true,
                isHistoricalGrid: true,
                isRSAdmin: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                "order": 0,
                "index": 18,
                "start_date": "2010-01-01",
                "end_date": "2030-01-01",
                "user_id": null,
                "title": "Call Back Requested",
                "dashboard_stats": "total_call_backs",
                "description": "Number of callback attempts.",
                "calls": 0,
                "role": REVIEWSCHEDULER,
                "isClickable": true,
                'hasAgentDropDown': true,
                "showName": true,
                isHistoricalGrid: true,
                isRSAdmin: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 28,
                index: 28,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Queued in Review",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'rs_queued_count',
                role: REVIEWSCHEDULER,
                isRSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "showHideBadPhoneNumberCheckbox": true,
                "back_to_dashboard": true
            },
            {
                order: 29,
                index: 29,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: EXTERNAL_RAC_COMPLETED_BY_CLIENT,
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'external_rac_files_count',
                role: REVIEWSCHEDULER,
                isRSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 30,
                index: 30,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES,
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'external_rac_files_count_inactive_agencies',
                role: REVIEWSCHEDULER,
                isRSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
        ]

    } else {
        buckets = [
            {
                order: 11,
                index: 11,
                direction: DESC,
                order_by: 'expiration_date',
                title: "Last Login",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                isClickable: false,
                dashboard_stats: "last_login",
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 4,
                index: 4,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Dials Made",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'dials_made',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 4,
                index: 4,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Upcoming Calls",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'upcoming_calls',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 2,
                index: 2,
                direction: DESC,
                isClickable: true,
                title: "Due Calls",
                description: "Profiles with present or expired active call date and are due to be scheduled.",
                calls: 0,
                dashboard_stats: 'due_calls',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 24,
                index: 24,
                direction: DESC, isClickable: true,
                order_by: 'von_appointment_date',
                title: "Total Scheduled Appointments",
                description: "Appointments scheduled in the selected time frame.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'total_appointments',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            // {
            //     order: 12,
            //     index: 12,
            //     direction: DESC, isClickable: true,
            //     order_by: 'expiration_date',
            //     title: "Dials Made",
            //     description: "Profiles with active call date in future.",
            //     calls: 0,
            //     loading: false,
            //     page: 1,
            //     total_pages: 0,
            //     dashboard_stats: "dails_made",
            //     role: VONBOARDER,
            //     isFSAdmin: true,
            //     user_id: null,
            //     showName: true,
            //     showMoreStats: true,
            //     "back_to_dashboard": true
            // },
            // {
            //     order: 13,
            //     index: 13,
            //     direction: DESC, isClickable: true,
            //     order_by: 'expiration_date',
            //     title: "Gap Times",
            //     description: "Profiles with active call date in future.",
            //     calls: 0,
            //     loading: false,
            //     page: 1,
            //     total_pages: 0,
            //     dashboard_stats: "gap_times",
            //     role: VONBOARDER,
            //     isFSAdmin: true,
            //     user_id: null,
            //     showName: true,
            //     showMoreStats: true,
            //     "back_to_dashboard": true
            // },
            {
                order: 14,
                index: 14,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Opportunity",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                dashboard_stats: 'FollowUp',
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 15,
                index: 15,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Lead",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                dashboard_stats: 'Prospect',
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 11,
                index: 11,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Thank you & referrals",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                dashboard_stats: 'Thank You / Referrals',
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 12,
                index: 12,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Life Insurance",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'Life Insurance',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 13,
                index: 13,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "P&C",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'Cross-Sell',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 14,
                index: 14,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Commercial/Farm",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'Commercial',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 15,
                index: 15,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Retirement",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'Retirement',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 5,
                index: 5,
                direction: DESC, isClickable: true,
                order_by: 'von_appointment_date',
                title: "Non Responsive",
                description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
                calls: 0,
                loading: false,
                dashboard_stats: 'total_non_responsive',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isLiveGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 20,
                index: 20,
                direction: DESC, isClickable: true,
                order_by: 'von_appointment_date',
                title: "Requested to be Rescheduled",
                description: "Appointments requested to be rescheduled by the agents",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'reschedule_appointments',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true

            },
            {
                order: 3,
                index: 3,
                direction: DESC, isClickable: true,
                order_by: 'von_appointment_date',
                title: "Not Interested",
                description: "Profiles that are marked as not interested.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'total_not_interested',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true

            },
            {
                order: 6,
                index: 6,
                direction: DESC, isClickable: true,
                order_by: 'von_appointment_date',
                title: "Bad Phone Number",
                description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
                calls: 0,
                dashboard_stats: 'bad_phone_number',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                showMoreStats: true,
                "back_to_dashboard": true
                // isLiveGrid: true
            },


            {
                order: 16,
                index: 16,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Re-Quotes",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                dashboard_stats: 'Re-Quote',
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 17,
                index: 17,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Win-Back",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                dashboard_stats: 'Win Back',
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 18,
                index: 18,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Event Call",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                dashboard_stats: 'Event Call',
                showName: true,
                isHistoricalGrid: true,
                isSubTypeOfCall: true,
                showMoreStats: true,
                "back_to_dashboard": true
            },
            {
                order: 22,
                index: 22,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Phone Appointments",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'phone_appointments',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                order: 21,
                index: 21,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Office Appointments",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'office_appointments',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },
            {
                order: 23,
                index: 23,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Virtual Appointments",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'virtual_appointments',
                role: VONBOARDER,
                hasAgentDropDown: true,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                "showHideBadPhoneNumberCheckbox": true,
            },




            {
                order: 27,
                index: 27,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Call Attempts",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'total_call_attempts',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },




            {
                order: 28,
                index: 28,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Queued in Lead",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'lead_queued_files',
                role: VONBOARDER,
                isFSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },




            {
                order: 29,
                index: 29,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: "Queued in Opportunity",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'opportunity_queued_files',
                role: VONBOARDER,
                isFSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },



            {
                order: 25,
                index: 25,
                direction: DESC, isClickable: true,
                order_by: 'expiration_date',
                title: "Call Back Requested",
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'total_call_backs',
                role: VONBOARDER,
                isFSAdmin: true,
                user_id: null,
                showName: true,
                isHistoricalGrid: true,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 30,
                index: 30,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: EXTERNAL_RAC_COMPLETED_BY_CLIENT,
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'external_rac_files_count',
                role: VONBOARDER,
                isFSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },
            {
                order: 31,
                index: 31,
                direction: DESC,
                isClickable: true,
                order_by: 'expiration_date',
                title: EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES,
                description: "Profiles with active call date in future.",
                calls: 0,
                loading: false,
                page: 1,
                total_pages: 0,
                dashboard_stats: 'external_rac_files_count_inactive_agencies',
                role: VONBOARDER,
                isFSAdmin: false,
                user_id: null,
                showName: true,
                isHistoricalGrid: false,
                showMoreStats: true,
                "back_to_dashboard": true,
                showHideBadPhoneNumberCheckbox: true
            },



        ];
    }
    return buckets;
};


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/grid/RS-FS-Admin-Buckets.js